module.exports = __webpack_public_path__ + "SamsungOne-400.ee07c375cd82fa85151c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-400.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-400.ttf
// module chunks = styles